import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { RegrasIbsCbsEntrada } from './RegrasIbsCbsEntrada';
import { TabelaDePara } from './TabelaDePara';

export function SefazTab() {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-widest mb-4">
          IMPOSTOS
        </h3>

        <div className="space-y-6">
          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="text-sm font-semibold">Regras de IBS/CBS na entrada</CardTitle>
            </CardHeader>
            <CardContent>
              <RegrasIbsCbsEntrada />
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="pb-3">
              <CardTitle className="text-sm font-semibold">Regras de x para ICMS</CardTitle>
            </CardHeader>
            <CardContent>
              <TabelaDePara tipo="icms" />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
